import React, { useEffect, useMemo, useState } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function EditarMarca({
  initial,
  onClose = () => {},
  onSaved = () => {},
}) {
  const id = useMemo(() => initial?.id ?? null, [initial]);
  const [descricao, setDescricao] = useState(initial?.descricao || "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const isValid = descricao.trim() !== "";
  const changed = useMemo(() => {
    return descricao !== (initial?.descricao || "");
  }, [descricao, initial]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const handleSave = async () => {
    if (!id || !changed || !isValid || saving) return;

    setSaving(true);
    setError("");

    try {
      const payload = { descricao: descricao.trim() };
      const updated = await appFetchJson(apiRoutes.marcas.update(id), {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      onSaved(updated);
      onClose();
    } catch (e) {
      console.error("Error actualizando marca:", e);
      setError(e?.message || "Error al actualizar la marca.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Editar Marca</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">
            Modifique la descripción de la marca
          </p>

          {error && (
            <div className="text-red-600 mb-3 font-medium">{error}</div>
          )}

          <div className="form-grid">
            <div className="form-row">
              <label className="form-label">Descripción *</label>
              <input
                type="text"
                className="input"
                value={descricao}
                onChange={(e) => setDescricao(e.target.value)}
                placeholder="Descripción de la marca"
              />
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar
              label="Guardar"
              isValid={isValid && changed}
              saving={saving}
              onClick={handleSave}
            />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}